// extracted by mini-css-extract-plugin
export default {"ImgEdit":"ImgEdit_ImgEdit__99tXo","label":"ImgEdit_label__fefgF","typeSelect":"ImgEdit_typeSelect__X6tM0"};